import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import bookingActions from 'actions/bookings/actions'
import Table from 'components/shared/table/table'
import THead from 'components/shared/table/table-header'
import TBody from 'components/shared/table/table-body'
import TRow from 'components/shared/table/table-row-dropdown'
import TCol from 'components/shared/table/table-column'
import TablePagination from 'components/shared/table/table-pagination'
import SortedUp from 'components/shared/icons/sortedUp'
import SortedDown from 'components/shared/icons/sortedDown'
import SortIcon from 'components/shared/icons/sort'

const ArchiveListLostTransaction = ({
  fetchArchiveLostTransactions,
  selectedVenue,
  list,
  page,
  limit,
  total,
  sortArchive,
  pageArchive,
  headers,
  sort,
}) => {
  useEffect(() => {
    fetchArchiveLostTransactions({ selectedVenue })
  }, [page, limit, sort, selectedVenue])

  const DisplayDetails = (item) => {
    const { requestDate, notes, client, email, phone } = item

    return (
      <ul className="my-3 text-sm">
        <li>{`Request Date: ${requestDate}`}</li>
        <li>{`Notes: ${notes}`}</li>
        <li>{`Client Name: ${client}`}</li>
        <li>{`Email: ${email}`}</li>
        <li>{`Phone: ${phone}`}</li>
      </ul>
    )
  }

  return (
    <>
      <div className="overflow-auto py-5">
        <Table classes="w-full border-collapse">
          <THead classes="text-xs bg-lightgray font-semibold">
            {headers.map((header, key) => {
              let sortIcon = <SortIcon />
              let nextOrder
              if (sort.field === header.field) {
                if (sort.order === 'asc') {
                  sortIcon = <SortedUp />
                  nextOrder = 'desc'
                } else {
                  sortIcon = <SortedDown />
                  nextOrder = 'asc'
                }
              }

              return (
                <TCol
                  classes="p-3 text-primary-black"
                  key={key}
                  align={header.align || 'left'}
                  onClick={() =>
                    header.sortable &&
                    sortArchive({
                      sort: { field: header.field, order: nextOrder },
                      sub: 'lostTransactions',
                    })
                  }
                >
                  <div
                    className={`flex items-center gap-1 ${header.sortable ? 'cursor-pointer' : ''}`}
                  >
                    {header.name} {header.sortable && sortIcon}
                  </div>
                </TCol>
              )
            })}
          </THead>
          <TBody>
            {list.map((item) => (
              <TRow
                classes="border-t text-sm hover:bg-gray-100"
                key={item.id}
                PassedComponent={() => DisplayDetails(item.details)}
              >
                <TCol classes="p-3">{item.createDate}</TCol>
                <TCol classes="p-3">{item.date}</TCol>
                <TCol classes="p-3">{item.client}</TCol>
                <TCol classes="p-3 text-primary-orange">
                  <a href={item.spaceLink}>{item.space}</a>
                </TCol>
                <TCol classes="p-3">
                  <span className="bg-secondary-lightorange font-semibold text-xs text-primary-orange px-3 py-1 uppercase rounded-lg">
                    {item.status}
                  </span>
                </TCol>
              </TRow>
            ))}
          </TBody>
        </Table>
      </div>
      <TablePagination
        currentPage={page}
        onPageChange={(newPage) => pageArchive({ lostTransactions: { page: newPage } })}
        onPageSizeChange={(newPageSize) => pageArchive({ lostTransactions: { limit: newPageSize } })}
        pageSize={limit}
        totalCount={total}
        className="mt-5"
      />
    </>
  )
}

ArchiveListLostTransaction.propTypes = {
  headers: PropTypes.array.isRequired,
  list: PropTypes.array,
  selectedVenue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  fetchArchiveLostTransactions: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  pageArchive: PropTypes.func.isRequired,
  sort: PropTypes.object.isRequired,
  sortArchive: PropTypes.func.isRequired,
}

const mapStateToProps = ({ bookings }) => ({
  headers: bookings.merchant.archive.lostTransactions.headers,
  sort: bookings.merchant.archive.lostTransactions.sort,
  list: bookings.merchant.archive.lostTransactions.list,
  page: bookings.merchant.archive.lostTransactions.page,
  limit: bookings.merchant.archive.lostTransactions.limit,
  total: bookings.merchant.archive.lostTransactions.total,
})

const mapDispatchToProps = {
  fetchArchiveLostTransactions: bookingActions.fetchMerchantLostArchivedTransactions,
  pageArchive: bookingActions.pageMerchantArchive,
  sortArchive: bookingActions.sortMerchantArchive,
}

export default connect(mapStateToProps, mapDispatchToProps)(ArchiveListLostTransaction)
